import { render, staticRenderFns } from "./imgvideo.vue?vue&type=template&id=84234b7e"
import script from "./imgvideo.vue?vue&type=script&lang=js"
export * from "./imgvideo.vue?vue&type=script&lang=js"
import style0 from "./imgvideo.vue?vue&type=style&index=0&id=84234b7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports